export default __webpack_public_path__ + "static/media/53.f854a5b0.jpeg";